<template>

    <div>

        <div class="invoice-logo">
            <div class="line"></div>
            <div class="border-img">
                <div class="background-img">
                    <img :src="logo" alt="">
                </div>
            </div>
        </div>
        <div class="name-company">
            <h4> {{companyName}} </h4>
        </div>
    </div>

</template>


<script>

    export default {
        props: ["companyName", "logo"],
        mounted() {
        }
    }

</script>


<style scoped>
    .invoice-logo {
        width: 100%;
        background-color: rgb(230, 225, 225);
        display: flex;
        justify-items: center;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }

    .name-company{
        display: flex;
        justify-items: center;
        justify-content: center;
        align-items: center;
    }
    .border-img{
        z-index: 100;
        background-color: white;
        display: flex;
        justify-items: center;
        justify-content: center;
        align-items: center;
        align-content: center;
        width: 80px;
        border-radius: 50px;
        border: solid 2px #333333;
        height: 80px;
    }
    .invoice-logo img {
        width: 60px;
        height: 60px;
        z-index: 1000;
        justify-self: center;
    }

    .background-img{
        width: 74px;
        height: 74px;
        background-color: #333333;
        border-radius: 50px;
        display: flex;
        justify-items: center;
        justify-content: center;
        padding-top: 8px;
    }

    .name-company h4 {
        font-size: 15px;
        color: #222;
        letter-spacing: 8px;
        word-spacing: 5px;
        font-weight: unset;
        z-index: 1000;
        margin-top: 15px;

    }

    .line {
        z-index: 0;
        width: 40%;
        height: 3px;
        background-color: #333333;
        position: absolute;
    }
</style>